import { STATUS_FINISHED } from 'services/constants';
import config from 'config';

// Services
import { getAppointmentViewState } from 'src/services/functions';
import { STATUS_PAID, STATUS_BOOKED, ROLES } from 'src/services/constants';

// Components
import Step from './Step';

// Styles & Images
import ResetClockRed from 'assets/images/practitioner/reset-clock-red.svg';
import { StepsList, WorkflowWrapper, ResetWorkflowRow, TriggerButton } from './styles';


export default ({
  i18n,
  creator,
  actions,
  activeAppointment,
  openVerifyModal,
  openPaymentModal,
  openRadiologyModal,
  appointment: { timeline, patient, invoice },
  role
}) => {
  const prepareTimeline = timeline.filter(step => {
    if (role === ROLES.RADIOLOGY) {
      // exclude some blocks by roles
      if (step.status !== 'Hidden') {
        if (step.state.match('radiology_') ||
          step.block.name === 'arrive' ||
          step.block.name === 'booking') {
          return step;
        } else {
          const radiologyAction = step.triggers.find(t => t.match('radiology_'));
          if (radiologyAction) {
            step.triggers = [radiologyAction];
            return step;
          }
        }
      }
    } else {
      return step.status !== 'Hidden';
    }
  });

  const isShowResetBtn = () => {
    const apStatus = getAppointmentViewState(activeAppointment);
    return role !== ROLES.RADIOLOGY &&
      apStatus !== STATUS_PAID && apStatus !== STATUS_BOOKED && invoice.status !== 'Paid';
  };

  return (
    <WorkflowWrapper>
      {isShowResetBtn() && (
        <ResetWorkflowRow>
          <button
            onClick={() => {
              actions.triggerWorkflow('consultation_reset', activeAppointment.id);
              actions.clearInvoice();
            }}
          >
            <img src={ResetClockRed} alt="reset workflow icon" />
            <span>{i18n.t('reset_workflow')}</span>
          </button>
        </ResetWorkflowRow>
      )}

      <StepsList isFinished={'timeline.currentStatus' === STATUS_FINISHED}>
        {prepareTimeline.map((item, i) => (
          <Step
            key={Math.random()}
            i18n={i18n}
            step={{ ...item, number: i + 1, index: i }}
            actions={actions}
            creator={creator}
            activeAppointment={activeAppointment}
            patient={patient}
            openPaymentModal={openPaymentModal}
            openVerifyModal={openVerifyModal}
            openRadiologyModal={openRadiologyModal}
          />
        ))}
      </StepsList>

      <TriggerButton onClick={() => {
        window.open(`${config.baseUrl}/practitioner/appointments/${activeAppointment && activeAppointment.id}/appointment/video`, '', 'width=1280,height=768');
      }} >Start Video Consultations</TriggerButton>

    </WorkflowWrapper>
  );
};
